import TmrBaseResource from './TmrBaseResource'

export default class SessionItems extends TmrBaseResource {
  static endpoint = '/sessionItems'
}
